import { render, staticRenderFns } from "./CompanyBusinessAdminsList.vue?vue&type=template&id=210b8050"
import script from "./CompanyBusinessAdminsList.vue?vue&type=script&lang=js"
export * from "./CompanyBusinessAdminsList.vue?vue&type=script&lang=js"
import style0 from "./CompanyBusinessAdminsList.vue?vue&type=style&index=0&id=210b8050&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports